export const undefinedOnEmpty = (value: string): string | undefined => {
  if (value === "") return undefined;

  return value;
};
